export default __webpack_public_path__ + "static/media/logo2.5670247b.PNG";